module.exports = __webpack_public_path__ + "public/images/program/program-21.7ecfeb27aeb180861911aa9853d00a28.jpg";